import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function Cookies() {
  useEffect(() => { document.title = 'Política de Cookies — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Política de" titleAccent="Cookies" subtitle="Información sobre el uso de cookies en la plataforma Sttora." breadcrumb="Política de Cookies">
      <div className="legal-updated">Última actualización: Enero 2026</div>
      <div className="legal-content">
        <p>Sttora utiliza cookies y tecnologías similares para mejorar tu experiencia de navegación, analizar el uso de la plataforma y personalizar contenido.</p>
        <h2>¿Qué son las Cookies?</h2>
        <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten recordar tus preferencias y mejorar la funcionalidad de la plataforma.</p>
        <h2>Tipos de Cookies que Usamos</h2>
        <ul>
          <li><strong>Esenciales:</strong> Necesarias para el funcionamiento básico de la plataforma. No pueden desactivarse.</li>
          <li><strong>Analíticas:</strong> Nos ayudan a entender cómo los usuarios interactúan con la plataforma usando herramientas anonimizadas.</li>
          <li><strong>Funcionales:</strong> Recuerdan tus preferencias de idioma, región y configuración de cuenta.</li>
          <li><strong>De marketing:</strong> Permiten mostrar contenido relevante. Solo se activan con tu consentimiento explícito.</li>
        </ul>
        <h2>Gestión de Cookies</h2>
        <p>Puedes gestionar o deshabilitar las cookies desde la configuración de tu navegador. Ten en cuenta que deshabilitar ciertas cookies puede afectar la funcionalidad de la plataforma.</p>
        <h2>Cookies de Terceros</h2>
        <p>Algunos servicios integrados (pasarelas de pago, mapas, análisis) pueden establecer sus propias cookies. Sttora no controla estas cookies de terceros.</p>
        <h2>Consentimiento</h2>
        <p>Al continuar usando la plataforma Sttora, aceptas el uso de cookies conforme a esta política.</p>
        <h2>Contacto</h2>
        <p>Para consultas sobre cookies: <a href="mailto:privacidad@sttora.com">privacidad@sttora.com</a></p>
      </div>
    </InnerLayout>
  );
}
